// 前端用户认证相关 API 封装
import http from './http';
import { setTokens, clearTokens, setUser } from './storage';

// 登录
export async function login({ username, password }) {
  const { data } = await http.post('user/login/', { username, password });
  // 期望后端返回 { message, user, refresh, access }
  setTokens(data.access, data.refresh);
  setUser(data.user);
  return data;
}

// 注册
export async function register(payload) {
  // payload: { username, password, confirm_password, email?, id_card?, phone? }
  const { data } = await http.post('user/register/', payload);
  // 注册成功也返回令牌与用户信息
  setTokens(data.access, data.refresh);
  setUser(data.user);
  return data;
}

// 登出
export async function logout() {
  try {
    // 如需传 refresh，可从存储取出，这里先不强制
    await http.post('user/logout/', {});
  } finally {
    clearTokens();
  }
}

// 获取当前用户信息
export async function getProfile() {
  const { data } = await http.get('user/profile/');
  return data;
}

// 更新当前用户信息（部分更新）
export async function updateProfile(partial) {
  const { data } = await http.put('user/profile/', partial);
  setUser(data);
  return data;
}
